import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RrNavLink } from 'react-router-dom';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Menues from '../Menues';
import { childrenOf, visibleItems, isGroup, containsPath, findSection } from '../Sidebar/menuUtils';

import './SubNav.css';

/** Pestaña con link interno. */
const TabLink = ({ item, active, className }) => (
    <span className="subnav-link">
        <RrNavLink to={item.url} className={className} isActive={() => active}>
            {item.name}
        </RrNavLink>
    </span>
);

/**
 * Barra de subsecciones de la sección activa del sidebar, arriba del contenido.
 * Las subsecciones con hijos se muestran como desplegable.
 */
class SubNav extends Component {
    static propTypes = {
        path: PropTypes.string.isRequired,
    }

    componentDidMount() {
        this.updateBodyClass();
    }

    componentDidUpdate() {
        this.updateBodyClass();
    }

    componentWillUnmount() {
        document.body.classList.remove('subnav-visible');
    }

    /**
     * Marca el body cuando la barra está visible, igual que hace CoreUI con
     * sidebar-minimized. Las vistas calculan su alto contra 100vh y con esta
     * clase SubNav.css les descuenta el alto de la barra.
     */
    updateBodyClass = () => {
        document.body.classList.toggle('subnav-visible', !!this.getSection());
    }

    /** La sección activa, solo si tiene subsecciones (si no, no hay barra). */
    getSection = () => {
        const section = findSection(Menues.items, this.props.path);
        return section && isGroup(section) ? section : null;
    }

    renderTab = (item) => {
        const { path } = this.props;
        const active = containsPath(item, path);

        // Abre un modal (ParadigmaModal con navButton)
        if (item.component) {
            return <item.component key={item.name} nav={{ ...item, icon: null, className: 'subnav-tab' }} />;
        }

        if (isGroup(item)) {
            // inNavbar evita que reactstrap remonte el menú al abrir/cerrar,
            // lo que cerraría los modales que viven adentro.
            return (
                <UncontrolledDropdown key={item.name} inNavbar className="subnav-dropdown">
                    <DropdownToggle tag="a" href="#" caret onClick={e => e.preventDefault()} className={'subnav-tab' + (active ? ' active' : '')}>
                        {item.name}
                    </DropdownToggle>
                    <DropdownMenu>
                        {visibleItems(childrenOf(item)).map(child =>
                            child.component ?
                                <child.component key={child.name} nav={{ ...child, className: 'dropdown-item' }} /> :
                                <DropdownItem
                                    key={child.name}
                                    tag={RrNavLink}
                                    to={child.url}
                                    active={containsPath(child, path)}
                                >
                                    {child.icon && <i className={child.icon}></i>}{child.name}
                                </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        return (
            <TabLink
                key={item.name}
                item={item}
                active={active}
                className={'subnav-tab' + (active ? ' active' : '')}
            />
        );
    }

    render() {
        const section = this.getSection();
        if (!section) return null;

        return (
            <div className="subnav">
                <span className="subnav-title">
                    <i className={section.icon}></i>{section.name}
                </span>
                <nav className="subnav-tabs">
                    {visibleItems(childrenOf(section)).map(this.renderTab)}
                </nav>
            </div>
        );
    }
}

export default SubNav;



// WEBPACK FOOTER //
// ./src/components/SubNav/SubNav.js